import { ContactCredit } from "../../operation/contacts/credits/ContactCreditData";
import { AgTechQuery } from "@agtech/core/data/queries/AgTechDataQueries";

/// DTOs

export type LotsByContactDTO = {
    id: number,
    lotNumber: string,
    invoiceId?: number,
    isSplit: boolean,
    invoiceState: number
}

export type InvoiceModifierOnInvoiceDTO = {
    id: number,
}

///
/// Queries
///

export const InvoiceDataGetInvoiceLotsQuery: AgTechQuery<{ saleId: number, invoiceId: number, contactId: number }, LotsByContactDTO[]> = {
    queryKey: (props) => ['InvoiceLots', props.invoiceId, props.contactId],
    query: (props) => {
        return props.http.getEntity({
            request: `Lot/${props.inputData.saleId}/LotsByContact/${props.inputData.contactId}/${props.inputData.invoiceId}`
        });
    },
    content: {
        loadingText: 'Loading lots...',
        failureText: 'Failed to load lots.'
    }
}

export const InvoiceDataGetInvoiceInvoiceModifiersQuery: AgTechQuery<number, InvoiceModifierOnInvoiceDTO[]> = {
    queryKey: (invoiceId) => ['InvoiceInvoiceModifiers', invoiceId],
    query: (props) => {
        return props.http.getEntity({
            request: `Invoice/${props.inputData}/InvoiceModifiers`
        });
    },
    content: {
        loadingText: 'Loading charges and discounts...',
        failureText: 'Failed to load charges and discounts.'
    }
}

export const InvoiceDataGetInvoiceCreditsQuery: AgTechQuery<{ invoiceId: number, contactId: number }, ContactCredit[]> = {
    queryKey: (props) => ['InvoiceCredits', props.invoiceId, props.contactId],
    query: (props) => {
        return props.http.getEntity({
            request: `Invoice/${props.inputData.invoiceId}/ChangeCredits/${props.inputData.contactId}`
        });
    },
    content: {
        loadingText: 'Loading credits...',
        failureText: 'Failed to load credits.'
    }
}
